module.exports = "/images/vendor/flag-icon-css/flags/4x3/br.svg?87032851c3532c9dd64f20f4bee155a9";